import React from 'react';
import { I_DirectionList } from '@Redux/detail/Group/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import FlightList from './FlightList';
import cN from 'classnames';
import styles from '../styles.module.scss';

interface I_Props {
    directions: I_DirectionList[];
}

const DirectionList: React.FC<I_Props> = ({ directions }) => {
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    return (
        <>
            {directions.map((direction: I_DirectionList, i: number) => (
                <div key={i} className={cN(styles['flights__sub'], [isPrint ? 'sub' : ''])}>
                    <h4>{direction.Name}</h4>
                    <FlightList flights={direction.FlightList} isBack={direction.Name === '回程'} />
                </div>
            ))}
        </>
    );
};

export default DirectionList;
